module.exports = __webpack_public_path__ + "img/skin_active_menu_type_default.3ea7682b.png";